import { Avatar, Button, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { UploadFilePurple } from 'Images';
import { forwardRef } from 'react';
interface IUploadFileButton {
  clickHandler: () => void;
  children?: any;
  dataRequired?: boolean;
  ariaLabel?: string;
  dataRequiredWith?: number[];
  dataId?: string;
  additionalFileAttachment?: boolean;
}
export const UploadFileButton = forwardRef<
  HTMLButtonElement,
  IUploadFileButton
>((props, ref) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Requests);
  const dataRequired = props.dataRequired ? dictionary.requiredDoc : '';
  const dataRequiredWith = props.dataRequiredWith
    ? JSON.stringify(props.dataRequiredWith)
    : '';
  const dataId = props.dataId ? props.dataId : '';
  const ariaLabel = props.additionalFileAttachment
    ? `${dictionary.additionalFileAttachment} - ${
        props.ariaLabel || ''
      } ${dataRequired}`
    : `${dictionary.upload}  - ${props.ariaLabel || ''} ${dataRequired}`;

  const isDesktop = useIsDesktop();

  return (
    <Button
      aria-required={props.dataRequired ? 'true' : 'false'}
      data-required={props.dataRequired ? 'true' : 'false'}
      data-required-with={dataRequiredWith}
      data-id={dataId}
      ref={ref}
      variant='outlined'
      sx={{
        width: '100%',
        height: '42px',
        bgcolor: isDesktop ? 'primary.shade_100' : 'white',
        color: 'text.primary',
        padding: '5px 10px 5px 20px',
        borderRadius: '6px',
        borderColor: 'primary.shade_200',
        justifyContent: 'space-between',
        '&:hover, &:focus': {
          bgcolor: isDesktop ? 'primary.shade_100' : 'white',
          borderColor: 'primary.shade_200',
        },
      }}
      onClick={props.clickHandler}
      aria-label={ariaLabel}
      endIcon={
        <Avatar
          alt=''
          src={UploadFilePurple}
          sx={{ width: '26px', height: '26px' }}
        />
      }
      aria-haspopup='true'
    >
      <Typography variant={isDesktop ? 'body2' : 'body3'}>
        {props.children}
      </Typography>
    </Button>
  );
});
